import { FC } from 'react';
import { Typography, Box } from '@mui/material';
import InstitucionalDocuments from '@/components/common/institutionalDocuments';


const Features: FC = () => {
  return (
    <section>
      <InstitucionalDocuments/>
     <Box
        sx={{
          marginTop: '2rem',
          width: '100%',
          height: { xs: 180, md: 200, lg: 220 },
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          backgroundImage: `url('/images/home-stats.jpg')`,
        }}
      >
        <Box sx={{
          position: 'absolute',
          inset: 0,
          backgroundImage: `url('images/img11.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          '&::before': {
            content: '""',
            position: 'absolute',
            inset: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
            transition: 'background-color 0.3s ease',
          },
          '&:hover::before': {
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
          },
        }}>
          <Box sx={{
            maxWidth: 1100,
            width: '100%',
            display: 'flex',
            gap: { xs: '1rem', md: '1.5rem', lg: '2rem' },
            padding: '0 1rem',
            justifyContent: 'center',
            position: 'relative',
            zIndex: 1,
          }}>
            <Box sx={{
              color: '#fff',
              textAlign: 'center',
              flex: { xs: '0 1 auto', sm: '1 1 auto' },
            }}>
              <Typography
                variant="h3"
                component="div"
                sx={{
                  fontWeight: 700,
                  letterSpacing: '1px',
                  fontSize: { xs: '1.5rem', sm: '1.75rem', md: '2rem' },
                }}
              >
                30
              </Typography>
              <Typography
                variant="subtitle1"
                component="div"
                sx={{
                  fontWeight: 600,
                  marginTop: '6px',
                  fontSize: { xs: '0.75rem', sm: '0.813rem', md: '0.875rem' },
                }}
              >
                AÑOS DE TRAYECTORIA
              </Typography>
            </Box>

            <Box sx={{
              color: '#fff',
              textAlign: 'center',
              flex: { xs: '0 1 auto', sm: '1 1 auto' },
            }}>
              <Typography
                variant="h3"
                component="div"
                sx={{
                  fontWeight: 700,
                  letterSpacing: '1px',
                  fontSize: { xs: '1.5rem', sm: '1.75rem', md: '2rem' },
                }}
              >
                2717
              </Typography>
              <Typography
                variant="subtitle1"
                component="div"
                sx={{
                  fontWeight: 600,
                  marginTop: '6px',
                  fontSize: { xs: '0.75rem', sm: '0.813rem', md: '0.875rem' },
                }}
              >
                ESTUDIANTES
              </Typography>
            </Box>

            <Box sx={{
              color: '#fff',
              textAlign: 'center',
              flex: { xs: '0 1 auto', sm: '1 1 auto' },
            }}>
              <Typography
                variant="h3"
                component="div"
                sx={{
                  fontWeight: 700,
                  letterSpacing: '1px',
                  fontSize: { xs: '1.5rem', sm: '1.75rem', md: '2rem' },
                }}
              >
                5
              </Typography>
              <Typography
                variant="subtitle1"
                component="div"
                sx={{
                  fontWeight: 600,
                  marginTop: '6px',
                  fontSize: { xs: '0.75rem', sm: '0.813rem', md: '0.875rem' },
                }}
              >
                SEDES EDUCATIVAS
              </Typography>
            </Box>

          </Box>
        </Box>
      </Box>

    </section>
  );
};

export default Features;
